<template>
  <div class="container page">
    <AppToolbar
      :title="vessel ? $t('message.manage_vessel_title', { vesselName: vessel.name }) : ''"
      :prev-route="vessel ? { name: 'VesselShow', params: { id: $iriToId(vessel['@id']) } } : null"
    ></AppToolbar>

    <div v-if="isLoading" class="dialog-spinner">
      <v-progress-circular indeterminate size="50" color="primary"></v-progress-circular>
    </div>
    <v-form
      v-else-if="unboundVessel.roleInVessels && unboundVessel.roleInVessels.length > 0"
      ref="form"
      @submit.prevent="onSubmit(unboundVessel)"
    >
      <v-list two-line subheader class="elevation-1">
        <v-list-item v-for="item in unboundVessel.roleInVessels" :key="item.id">
          <v-list-item-avatar>
            <img
              v-if="item.user.image"
              :src="item.user.image.contentUrl + '?x-request=html'"
              :alt="item.user.firstName + ' ' + item.user.lastName"
            />
            <img v-else src="../../assets/no-img.svg" :alt="item.user.firstName + ' ' + item.user.lastName" />
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ item.user.firstName }} {{ item.user.lastName }}</v-list-item-title>
          </v-list-item-content>
          <v-list-item-action>
            <!--
            <v-checkbox :input-value="userInRoleInVessels(item.user)" value></v-checkbox>
            -->
            <v-select
              v-if="isAllowedVesselRole(item.vesselRole)"
              v-model="item.vesselRole"
              placeholder="No role in this vessel"
              :items="allowedVesselRoles"
              item-value="@id"
              item-text="name"
              :menu-props="{ maxHeight: '400' }"
              class="pt-0"
              :clearable="true"
            ></v-select>
            <span v-else class="grey--text">{{ $t('message.' + item.vesselRole.name) }}</span>
          </v-list-item-action>
        </v-list-item>
      </v-list>
    </v-form>
    <div v-else class="empty-state-sm">
      <v-icon size="64" class="grey--text text--lighten-2">mdi-account-supervisor-circle</v-icon>
      <p class="grey--text">{{ $t('message.there_are_no_employees_yet') }}</p>
    </div>
    <v-btn color="warning" fab fixed bottom right @click.native="save">
      <v-icon>mdi-content-save</v-icon>
    </v-btn>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import AppToolbar from '@/components/AppToolbar'

export default {
  components: {
    AppToolbar
  },

  data() {
    return {
      unboundVessel: {}
    }
  },
  computed: {
    ...mapGetters({
      vessel: 'vessel/update/retrieved',
      vesselUpdated: 'vessel/update/updated',
      vesselLoading: 'vessel/update/isLoading',
      error: 'vessel/update/error',
      violations: 'vessel/update/violations',
      roleInVessels: 'roleinvessel/list/items',
      roleInVesselsLoading: 'roleinvessel/list/isLoading',
      roleInOrganizations: 'roleinorganization/list/items',
      roleInOrganizationsLoading: 'roleinorganization/list/isLoading',
      vesselRoles: 'vesselrole/list/items',
      vesselRolesLoading: 'vesselrole/list/isLoading'
    }),

    isLoading: function() {
      return (
        this.roleInVesselsLoading || this.roleInOrganizationsLoading || this.vesselRolesLoading || this.vesselLoading
      )
    },

    allowedVesselRoles: function() {
      if (!this.vesselRoles) {
        return
      }

      // If is shipowner return all vessel roles
      if (this.$security.isGranted(this.vessel.organization, 'ROLE_SHIPOWNER')) {
        let vesselRoles = this.vesselRoles
        vesselRoles.forEach(vesselRole => {
          vesselRole.name = this.$t('message.' + vesselRole.name)
        })
        return vesselRoles
      }

      // Search children for user vessel role in current vessel
      const user = this.$security.getUser()
      const vesselRoleInCurrentVessel = user.roleInVessels.filter(roleInVessel => {
        return roleInVessel.vessel['@id'] === this.vessel['@id']
      })[0].vesselRole

      let childrenVesselRoles = []

      this.vesselRoles.forEach(vesselRole => {
        if (vesselRoleInCurrentVessel['@id'] === vesselRole['@id']) {
          // recursive get children from the vesselRole
          this.getChildrenFromVesselRole(vesselRole, childrenVesselRoles)
        }
      })

      childrenVesselRoles.forEach(vesselRole => {
        vesselRole.name = this.$t('message.' + vesselRole.name)
      })

      return childrenVesselRoles
    }
  },

  watch: {
    vesselUpdated() {
      this.$router.push({
        name: 'VesselShow',
        params: { id: this.$route.params.id }
      })
    },
    vessel: function(vessel) {
      if (!vessel) {
        return
      }

      this.roleInVesselsGetPage('/role_in_vessels?pagination=false&vessel=' + vessel['@id'])
      this.roleInOrganizationsGetPage(
        '/role_in_organizations?pagination=false&organization=' + vessel.organization['@id']
      )
      this.vesselRolesGetPage()
    },

    created: function(created) {
      if (!created) {
        return
      }

      this.$router.push({
        name: 'vesselShow',
        params: { id: this.$route.params.id }
      })
    },
    isLoading: function(isLoading) {
      if (isLoading) {
        return
      }

      let _this = this

      this.unboundVessel = JSON.parse(JSON.stringify(this.vessel))

      this.unboundVessel.organization.roleInOrganizations = JSON.parse(JSON.stringify(this.roleInOrganizations))
      this.unboundVessel.roleInVessels = JSON.parse(JSON.stringify(this.roleInVessels))

      this.roleInOrganizations.forEach(function(roleInOrganization) {
        if ('ROLE_MEMBER' === roleInOrganization.organizationRole.name) {
          let exists = false
          _this.unboundVessel.roleInVessels.forEach(function(roleInVessel) {
            if (roleInOrganization.user['@id'] === roleInVessel.user['@id']) {
              exists = true
            }
          })

          if (!exists) {
            _this.unboundVessel.roleInVessels.push({
              user: roleInOrganization.user,
              vessel: _this.unboundVessel['@id'],
              vesselRole: {}
            })
          }
        }
      })
    }
  },

  created() {
    this.retrieveVessel('/vessels/' + this.$route.params.id)
  },

  methods: {
    ...mapActions({
      roleInVesselsGetPage: 'roleinvessel/list/default',
      roleInOrganizationsGetPage: 'roleinorganization/list/default',
      vesselRolesGetPage: 'vesselrole/list/default',
      retrieveVessel: 'vessel/update/retrieve',
      resetVessel: 'vessel/update/reset',
      updateVessel: 'vessel/update/update'
    }),

    isAllowedVesselRole(vesselRole) {
      if ('undefined' === typeof vesselRole || !vesselRole) {
        return true
      }

      let isAllowed = false

      const vesselRoleId = 'string' === typeof vesselRole ? vesselRole : vesselRole['@id']

      this.allowedVesselRoles.forEach(allowedVesselRole => {
        if (vesselRoleId === allowedVesselRole['@id']) {
          isAllowed = true
        }
      })

      if (!vesselRoleId) {
        isAllowed = true
      }

      return isAllowed
    },

    getChildrenFromVesselRole(vesselRole, childrenVesselRoles) {
      if (vesselRole.children.length > 0) {
        vesselRole.children.forEach(childVesselRole => {
          childrenVesselRoles.push(childVesselRole)
          this.getChildrenFromVesselRole(childVesselRole, childrenVesselRoles)
        })
      } else {
        return childrenVesselRoles
      }
    },

    save() {
      this.onSubmit(this.unboundVessel)
    },

    onSubmit(unboundVessel) {
      let vessel = JSON.parse(JSON.stringify(unboundVessel))

      vessel.roleInVessels = vessel.roleInVessels.filter(function(roleInVessel) {
        if ('undefined' === typeof roleInVessel.vesselRole) {
          roleInVessel.vesselRole = {}
        }
        return roleInVessel.vesselRole['@id'] || 'string' === typeof roleInVessel.vesselRole
      })

      this.vessel.roleInVessels = vessel.roleInVessels

      this.$store.commit('vessel/update/VESSEL_UPDATE_SET_RETRIEVED', this.vessel)

      this.updateVessel()
    }
  }
}
</script>
